module.exports = __webpack_public_path__ + "assets/7ce30cb01f6bc0afabb493c253da15de.mp3";